import BarraProgressoCircular from '../BarraProgressoCircular';
import { post } from '../../services/api'
import { useEffect } from 'react'
import { useState } from 'react'
import leaoImagem from '../../assets/img/leao.svg'
import tigreImagem from '../../assets/img/tigre.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'
import girafaImagem from '../../assets/img/girafa.svg'
import hipopotamoImagem from '../../assets/img/hipopotamo.svg'
import zebraImagem from '../../assets/img/zebra.svg'
import vacaLeiteiraImagem from '../../assets/img/vaca.svg'
import jaguarImagem from '../../assets/img/jaguar.svg'
import suricatoImagem from '../../assets/img/suricato.svg'

function Animais({ idAnimal, nomeAnimal, indicadorAnimal, mesAno, idVendedor, loading, changeVendedor, changeMesAno, cargo, regiao, onPontuacaoAtualizada }) {

    useEffect(() => {
        limparDados();
        getAnimal();
    }, [idVendedor]);

    useEffect(() => {
        limparDados();
    }, [changeVendedor]);

    useEffect(() => {
        limparDados();
    }, [changeMesAno]);


    const [metaPrincipal, setMetaPrincipal] = useState(0);
    const [realizado, setRealizado] = useState(0);
    const [percentualRealizado, setPercentualRealizado] = useState(0);
    const [desvioPercentualRealizado, setDesvioPercentualRealizado] = useState(0);
    const [desvioPercentualProjetado, setDesvioPercentualProjetado] = useState(0);
    const [nivelRealizado, setNivelRealizado] = useState('-');
    const [pontuacaoRealizada, setPontuacaoRealizada] = useState(0);
    const [desvioRealizado, setDesvioRealizado] = useState(0);
    const [projetado, setProjetado] = useState(0);
    const [percentualProjetado, setPercentualProjetado] = useState(0);
    const [nivelProjetado, setNivelProjetado] = useState('-');
    const [pontuacaoProjetada, setPontuacaoProjetada] = useState(0);
    const [desvioProjetado, setDesvioProjetado] = useState(0);
    const [ideal, setIdeal] = useState(0);
    const [isFetchingData, setIsFetchingData] = useState(false);
    const [dadosIndiponiveis, setDadosIndisponiveis] = useState(false);
    const [avisoCard, setAvisoCard] = useState('');
    const [indicadorInativo, setIndicadorInativo] = useState(false);
    const [formatacaoValores, setFormatacaoValores] = useState('moeda');
    const [dadosDisponiveis, setDadosDisponiveis] = useState(false);

    function limparDados() {
        setRealizado(0);
        setFormatacaoValores('moeda');
        setPercentualRealizado(0);
        setDesvioPercentualRealizado(0);
        setDesvioPercentualProjetado(0);
        setDesvioRealizado(0);
        setNivelRealizado('-');
        setPontuacaoRealizada(0);
        setProjetado(0);
        setPercentualProjetado(0);
        setNivelProjetado('-');
        setPontuacaoProjetada(0);
        setDesvioProjetado(0);
        setIdeal(0);
        setDadosIndisponiveis(false);
        setIndicadorInativo(false);
        setMetaPrincipal(0);
        setDadosDisponiveis(false);
        setAvisoCard('');
    }

    function getCorPorNivel(nivel) {
        const roxo = '#7030a0';
        const vermelho = '#ff0000';
        const amarelo = '#ffff00';
        const verde = '#99ff99';
        const azul = '#bdd7ee';
        const cinza = '#949494';

        switch (nivel) {
            case 'E':
                return roxo;
            case 'D':
                return vermelho;
            case 'C':
                return amarelo;
            case 'B':
                return verde;
            case 'A':
                return azul;
            default:
                return cinza;
        }
    }

    function getImagem() {
        switch (idAnimal) {
            case 1:
                return leaoImagem;
            case 2:
                return tigreImagem;
            case 3:
                return pinguimImagem;
            case 4:
                return girafaImagem;
            case 5:
                return zebraImagem;
            case 6:
                return hipopotamoImagem;
            case 7:
                return jaguarImagem;
            case 8:
                return vacaLeiteiraImagem;
            case 10:
                return suricatoImagem;
            case 11:
                return zebraImagem;

        }
    }

    async function getAnimal() {
        try {

            if (idVendedor) {
                const [mes, ano] = mesAno.split('-');

                let requisicao;
                let response;

                setIsFetchingData(true);
                loading(idAnimal, false)

                if (cargo == 'GERENTE_REGIONAL') {
                    requisicao = { regiao: regiao, mes: mes, ano: ano, idAnimal: idAnimal };
                    response = await post('/animais/getanimalregional', requisicao);

                } else {
                    requisicao = { vendedor: idVendedor, mes: mes, ano: ano, idAnimal: idAnimal, detalhado: false };
                    response = await post('/animais/getanimal', requisicao);
                }

                loading(idAnimal, true)
                setIsFetchingData(false);

                if (response.status.metaIndisponivel) {
                    setDadosIndisponiveis(true);
                    setAvisoCard(response.Mensagem);
                    return;
                }

                if (response.status.indicadorIndisponivel) {
                    setDadosIndisponiveis(true);
                    setAvisoCard(response.Mensagem);
                    setIndicadorInativo(true);
                    return;
                }

                if (response.avisos && response.avisos.length > 0) {
                    setAvisoCard(response.avisos.join(' - '));
                }

                if (response.status === 'OK') {
                    setFormatacaoValores(response.formatacao.valores);
                    setMetaPrincipal(response.card.metaPrincipal);
                    setRealizado(response.card.realizado);
                    setProjetado(response.card.projetado);
                    setPercentualRealizado(response.card.percentualRealizado);
                    setPercentualProjetado(response.card.percentualProjetado);
                    setPontuacaoRealizada(response.card.pontuacaoRealizada);
                    setPontuacaoProjetada(response.card.pontuacaoProjetada);
                    setNivelRealizado(response.card.nivelRealizado);
                    setNivelProjetado(response.card.nivelProjetado);
                    setIdeal(response.card.ideal);
                    setDesvioRealizado(response.card.desvioRealizado);
                    setDesvioProjetado(response.card.desvioProjetado);
                    setDesvioPercentualRealizado(response.card.desvioPercentualRealizado);
                    setDesvioPercentualProjetado(response.card.desvioPercentualProjetado);
                    setDadosDisponiveis(true);

                    onPontuacaoAtualizada(response.card.pontuacaoRealizada, response.card.pontuacaoProjetada);
                } else {
                    setDadosIndisponiveis(true);
                    setAvisoCard('Dados indisponíveis');
                }
            }
        } catch (error) {
            setDadosIndisponiveis(true);
            setAvisoCard('Dados indisponíveis');
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function formatarValor(valor) {
        try {
            if (dadosIndiponiveis) {
                return '-';
            }

            const percentualFormatado = valor.toFixed(2).replace('.', ',');
            return formatacaoValores == 'percentual' ? `${percentualFormatado.toLocaleString('pt-BR')}%` : valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
        } catch (error) {
            console.error('Erro:', error.message);
        }
    }


    function formatarDesvioPercentual(valor) {
        try {
            if (dadosIndiponiveis) {
                return '-';
            }

            const percentualFormatado = parseFloat(valor).toFixed(2).replace('.', ',');

            if (valor < 0) {
                return `${percentualFormatado.toLocaleString('pt-BR')}%`;
            }

            return '+' + `${percentualFormatado.toLocaleString('pt-BR')}%`;

        } catch (error) {
            console.error('Erro:', error.message);
        }
    }

    function statusDetalhes() {
        try {
            if (isFetchingData) {
                return 'Carregando card...';
            } else if (dadosIndiponiveis) {
                return avisoCard;
            } else if (dadosDisponiveis && avisoCard !== '') {
                return avisoCard + ' - ' + 'Visualizar mais detalhes';
            } else {
                return 'Visualizar mais detalhes';
            }
        } catch (error) {
            console.error('Erro:', error.message);
        }
    }

    async function abrirPaginaAnimal() {
        try {
            if (dadosDisponiveis) {
                const dadosRequisicaoAnimal = {
                    vendedor: changeVendedor,
                    idAnimal: idAnimal,
                    mesAno: mesAno,
                    nomeAnimal: nomeAnimal,
                    indicadorAnimal: indicadorAnimal,
                    cargo: cargo,
                    regiao: regiao
                };
                sessionStorage.setItem('dadosRequisicaoAnimal', JSON.stringify(dadosRequisicaoAnimal));
                window.open('/animal');
            }
        } catch (error) {
            console.error('Erro:', error.message);
        }
    };

    return (
        <div className={`grid grid-cols-9 grid-rows-1 relative ${indicadorInativo ? 'card-disabled' : ''}`}>
            <div className="col-span-9 md:col-span-3 bg-gradient-to-b from-white to-gray-c8 text-center font-bold text-[22px] text-gray-c3 py-4 px-6 grid z-10 shadow-animal rounded-tr-[10px] md:rounded-tr-none">
                <div className="self-center">
                    <img src={getImagem()} alt={nomeAnimal} className="object-contain aspect-[3/4] max-w-full inline-block" />
                </div>
            </div>
            <div className="col-span-9 md:col-span-6 bg-gray-c4 px-4 pb-4 pt-[22px] grid rounded-tr-none md:rounded-tr-[10px]">
                <div className={`absolute top-0 max-[767px]:left-0 md:left-1/3 font-poppins text-black text-center bg-nivel-${nivelRealizado} rounded-br-[10px] py-1 px-2 z-[20]`}>
                    <p className="font-normal text-[8px]">Realizado</p>
                    <p className="font-semibold text-xl leading-none block">{nivelRealizado}</p>
                    <p className="font-semibold text-[10px]">{!dadosIndiponiveis ? pontuacaoRealizada : '-'}</p>
                </div>
                <p className="font-light text-gray-c5 text-sm leading-none pb-3">{indicadorAnimal}</p>
                <div className={`absolute top-0 right-0 font-poppins text-black text-center bg-nivel-${nivelProjetado} rounded-tr-[10px] rounded-bl-[10px] py-1 px-2 z-[20]`}>
                    <p className="font-normal text-[8px]">Projetado</p>
                    <p className="font-semibold text-xl leading-none block">{nivelProjetado}</p>
                    <p className="font-semibold text-[10px]">{!dadosIndiponiveis ? pontuacaoProjetada : '-'}</p>
                </div>
                <div>
                    <h4 className="font-bold text-gray-c5 text-lg leading-none">
                        <span className="text-2xl uppercase inline-block md:block pt-0 md:pt-1">{nomeAnimal}</span>
                    </h4>
                </div>


                <div className={`grid items-center gap-1 grid-cols-${formatacaoValores !== 'percentual' ? '4' : '3'} pt-4 font-mulish font-bold text-gray-c9`}>

                    <div>
                        <p className="font-light text-xs text-gray-c5 pb-[1px]">Realizado:</p>
                        <BarraProgressoCircular percentage={!dadosIndiponiveis ? percentualRealizado : null} color={getCorPorNivel(nivelRealizado)} styleWidth="60px" />
                    </div>
                    <div>
                        &nbsp;
                    </div>
                    {formatacaoValores !== 'percentual' && (
                        <div>
                            &nbsp;
                        </div>
                    )}
                    <div>
                        <p className="font-light text-xs text-gray-c5 pb-[1px]">Projetado:</p>
                        <BarraProgressoCircular percentage={!dadosIndiponiveis ? percentualProjetado : null} color={getCorPorNivel(nivelProjetado)} styleWidth="60px" />
                    </div>

                    <div className="pt-4">
                        <p className="text-xs font-semibold leading-none">Ideal:</p>
                        <span className="font-extrabold text-gray-c5 text-xs">{formatarValor(ideal)}</span>
                    </div>

                    <div className="pt-4">
                        <p className="text-xs font-semibold leading-none">Realizado:</p>
                        <span className="font-mulish font-extrabold text-xs text-green-c1 leading-none">{formatarValor(realizado)}</span>
                    </div>

                    {formatacaoValores !== 'percentual' && (
                        <div className="mx-3 relative pt-4">
                            <div className="self-end bg-white p-[0.15rem] rounded shadow-percentage mx-2 relative z-10">
                                <p className={`font-mulish font-bold text-xs1 ${parseFloat(desvioPercentualRealizado) < 0 ? 'text-red' : 'text-green'}-c1 leading-none`}>{formatarDesvioPercentual(desvioPercentualRealizado)}</p>
                            </div>
                        </div>
                    )}

                    <div className="pt-4">
                        <p className="text-xs font-semibold leading-none">Desvio:</p>
                        <h5 className={`font-extrabold text-gray-c5 ${parseFloat(desvioRealizado) < 0 ? 'text-red' : 'text-green'}-c1 text-xs`}>{formatarValor(desvioRealizado)}</h5>
                    </div>

                    <div>
                        <p className="text-xs font-semibold leading-none">Missão:</p>
                        <span className="font-extrabold text-gray-c5 text-xs">{formatarValor(metaPrincipal)}</span>
                    </div>

                    <div>
                        <p className="text-xs font-semibold leading-none">Projetado:</p>
                        <span className="font-mulish font-extrabold text-xs text-green-c1 leading-none">{formatarValor(projetado)}</span>
                    </div>

                    {formatacaoValores !== 'percentual' && (
                        <div className="mx-3 relative">
                            <div className="self-end bg-white p-[0.15rem] rounded shadow-percentage mx-2 relative z-10">
                                <p className={`font-mulish font-bold text-xs1 ${parseFloat(desvioPercentualProjetado) < 0 ? 'text-red' : 'text-green'}-c1 leading-none`}>{formatarDesvioPercentual(desvioPercentualProjetado)}</p>
                            </div>
                        </div>
                    )}

                    <div>
                        <p className="text-xs font-semibold leading-none">Desvio:</p>
                        <h5 className={`font-extrabold text-gray-c5 ${parseFloat(desvioPercentualProjetado) < 0 ? 'text-red' : 'text-green'}-c1 text-xs`}>{formatarValor(desvioProjetado)}</h5>
                    </div>


                </div>
                {(cargo === 'GERENTE_LOJA' && [1, 2, 3].includes(idAnimal)) && (
                    <div className='pt-4'>
                        <p className="text-xs leading-none">* Valores em média por vendedores da filial.</p>
                    </div>
                )}
            </div>
            <div className="col-span-9">
                <button
                    onClick={() => abrirPaginaAnimal()}
                    className="rounded-b-[10px] w-full text-center inline-block bg-gradient-to-b from-green-c3 to-green-c4 py-[10px] font-medium text-base text-white leading-none"
                >
                    {dadosDisponiveis && avisoCard !== '' ? (
                        <div className="marquee-wrapper">
                            <div className="marquee-content">
                                {statusDetalhes()}
                            </div>
                        </div>
                    ) : (
                        statusDetalhes()
                    )}
                </button>
            </div>
        </div>
    )
}

export default Animais